import Target from './target';

import { useSelector } from '../../../../../redux/store';
import { TargetSessionStatuses } from '../../../../../redux/API/ClientAPIHelpers/sessionsProperties';

const TargetList = () => {
	const targets = useSelector((state) => state.session.targets);
	const targetsList = targets.filter((x) => x.targetStatus === TargetSessionStatuses.new);

	return (
		<div className="targetsWrapper">
			{targetsList.map((target) => (
				<Target target={target} key={target.id} />
			))}
		</div>
	);
};

export default TargetList;
